
export const StringValidation = {
    /* This file contains custom validation utility functions to validate string values alone 
sample scenarios are below
 isNullOrEmpty("")         // true
 isNullOrEmpty("  ")       // true
 isNullOrEmpty(null)       // true
 isNullOrEmpty(undefined)  // true
 isNullOrEmpty("valid")    // false
*/
    isNullOrEmpty(value?: string | null): boolean {
        return !value || value.trim() === "";
    }
};

export const RestrictedDataValidation = {
    /* This file contains validation utility functions to check for restricted data values
sample scenarios are below
 isRestrictedData("NA")                    // true
 isRestrictedData("N/A")                   // true
 isRestrictedData("Not available")         // true
 isRestrictedData("NULL")                  // true
 isRestrictedData("Not Applicable")        // true
 isRestrictedData("n/a")                   // true (case-insensitive)
 isRestrictedData("null")                  // true (case-insensitive)
 isRestrictedData("not applicable")        // true (case-insensitive)
 isRestrictedData("valid data")            // false
 isRestrictedData("")                      // false
*/
    isRestrictedData(value?: string | null): boolean {
        if (!value) return false;
        
        const restrictedPatterns = [
            "NA",
            "N/A", 
            "Not available",
            "NULL",
            "Not Applicable",
            "n/a",
            "null",
            "not applicable",
            "not available"
        ];
        
        const trimmedValue = value.trim();
        // Case-insensitive comparison
        return restrictedPatterns.some(pattern => 
            trimmedValue.toLowerCase() === pattern.toLowerCase()
        );
    }
};
